import { DocumentService } from 'services/document/document.service';
import { call, put, takeEvery } from 'typed-redux-saga';
import { DeleteFilesAction, FetchFilesAction } from 'types/actions/document';

import { documentAction } from '../actions';
import { documentConstant } from '../actionTypes';

const getReadBlobToken = function* () {
  const data = yield* call(() => {
    return DocumentService.getReadToken();
  });
  yield* put(documentAction.updateReadToken(data));
};

const getFiles = function* (action: FetchFilesAction) {
  yield* put(documentAction.updateLoadingStatus(true));
  try {
    const data = yield* call(() => {
      return DocumentService.getListFiles({
        page: action?.payload?.page - 1,
        size: 10,
        file_name: action?.payload?.fileName,
        sort_field: action?.payload?.sortField,
        is_ascending: action?.payload?.isAscending,
        status: action?.payload?.status,
      });
    });
    if (data?.data) {
      yield* put(documentAction.getListFiles(data));
    }
  } catch (err) {
    console.log(err);
  } finally {
    yield* put(documentAction.updateLoadingStatus(false));
  }
};

const deleteFiles = function* ({ payload }: DeleteFilesAction) {
  yield* put(documentAction.updateLoadingStatus(true));
  try {
    yield* call(() => {
      return DocumentService.deleteFiles(payload);
    });
    // Refetch the list after delete - dispatch action to trigger refetch
    yield* put(
      documentAction.fetchFiles({
        page: 0,
        fileName: '',
        sortField: 'created_at',
        isAscending: false,
      })
    );
  } catch (err) {
    console.log(err);
    yield* put(documentAction.updateLoadingStatus(false));
  }
};

export const watchGetFiles = function* () {
  yield* takeEvery(documentConstant.GET_FILES, getFiles);
};

export const watchDeleteFiles = function* () {
  yield* takeEvery(documentConstant.DELETE_FILES, deleteFiles);
};

export const watchGetReadToken = function* () {
  yield* takeEvery(documentConstant.GET_READ_TOKEN, getReadBlobToken);
};
